import React from 'react';
import { InvoiceLineItem, SKU } from '../../../../redux/billing/billing.types';
import { Equal, Plus } from 'lucide-react';
import { formatCurrency, formatPercentage } from './utils';

interface InvoiceLineItemDetailCalcProps {
  lineItem: InvoiceLineItem;
  sku: SKU;
}

export const InvoiceLineItemDetailCalc: React.FC<InvoiceLineItemDetailCalcProps> = ({
  lineItem,
  sku,
}) => {
  const useOverrideValue = (field: keyof InvoiceLineItem) => {
    const overrideField = `${field}_override` as keyof InvoiceLineItem;
    const overrideValue = lineItem[overrideField];
    return overrideValue !== null && overrideValue !== undefined ? overrideValue : lineItem[field];
  };

  return (
    //
    <>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-gray-500'>
          Total
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(useOverrideValue('advertiser_spend') as number)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Spend
        </div>
      </div>
      <div>
        <Plus className='h-4 w-4' />
      </div>
      {/* <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatPercentage(lineItem.margin_pct_override || lineItem.margin_pct || 0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Margin Pct
        </div>
      </div> */}
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(lineItem.margin || 0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Margin
          {` (${formatPercentage((useOverrideValue('margin_pct') as number) ?? 0, 0)})`}
        </div>
      </div>
      <div>
        <Equal className='h-4 w-4' />
      </div>
      <div className='flex flex-col'>
        <div className='text-sm font-light text-transparent'>
          {'L'}
        </div>
        <div className='text-xl font-thin'>
          {formatCurrency(lineItem.amount_to_bill || 0)}
        </div>
        <div className='text-xs font-light text-gray-500'>
          Total
        </div>
      </div>
    </>
  );
};

export default InvoiceLineItemDetailCalc;
